import { refreshTableInfo } from '@dbl/services/dataSource';

/**
 * 主要为了实现 数据表管理页面右上的刷新逻辑
 * 产品要求 在刷新过程中, 如果切换其他页面, 再切换回数据表管理页面, 刷新的状态要保留
 * 刷新成功后要自动更新 类别 和 表格数据
 */

const initState = (): any => ({
  refreshStatus: 'normal', // 用来判断是否显示刷新成功失败
});

export const namespace = 'DataManagement/Tables';

export default {
  namespace,
  state: initState(),
  reducers: {
    changeRefreshStatus(state: any, action: {type: string; payload: string;}) {
      return {...state, refreshStatus: action.payload};
    }
  },
  effects: {
    // 刷新按钮
    *refreshTable({ payload }: { payload: any; callback: Function; }, { put, select }: { put: any; select: any; }) {
      try {
        const { gameCode } = yield select((state) => state.datalab);
        

        yield refreshTableInfo({game_code: gameCode});
        
        yield put({
          type: 'changeRefreshStatus',
          payload: 'success',
        });
      } catch (e) {
        yield put({
          type: 'changeRefreshStatus',
          payload: 'error',
        });
      }
    },

  },
};
